import { OfflinePrefetchProps } from "../interface";
import {
  usePrefetchUtils,
  executePaginatedPrefetch,
} from "../utils/usePrefetchUtils";
import { useLazyFluidOutputHistoryQuery } from "../../../api/staticFormsApi";
import { useDispatch } from "react-redux";
import { storeFluidOutput } from "../../../../store/slices/fluidOutput";
import { useCallback } from "react";
import { format, subDays } from "date-fns";
import { store } from "app/services/store";
import { FluidOutputHistoryResponse } from "app/services/api/types/forms/responses/FluidOutputHistoryResponse";
import { BASE_DAYS } from "./constants";

const HISTORY_DATE_FROM_DAYS = BASE_DAYS;

export function usePrefetchFluidOutput({ enabled }: OfflinePrefetchProps) {
  const [trigger] = useLazyFluidOutputHistoryQuery();
  const dispatch = useDispatch();

  const handlePrefetch = useCallback(async () => {
    const dateFrom = format(
      subDays(new Date(), HISTORY_DATE_FROM_DAYS),
      "yyyy-MM-dd",
    );

    await executePaginatedPrefetch<any, FluidOutputHistoryResponse>({
      name: "FluidOutput",
      trigger,
      buildQueryArgs: (page) => ({
        filter: {
          recorded_at_from: dateFrom,
        },
        limit: 100,
        page,
      }),
      storeData: (data) => dispatch(storeFluidOutput(data)),
      getLastPage: (data) => data?.meta?.last_page ?? 1,
      enableSmartCache: true,
      getFirstRecordId: (data) => data?.data?.[0]?.id ?? null,
      dispatch,
      getState: () => store.getState(),
    });
  }, [trigger, dispatch]);

  usePrefetchUtils({
    enabled,
    prefetchHandler: handlePrefetch,
  });
}
